var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWidgetScatter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.21,
    height: 18.785,
    viewBox: "0 0 27.21 18.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2518.512 -239.836) rotate(19)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2288.386 1049.889)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2286.781 1054.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2292.019 1053.824)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2292.624 1050.495)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2294.992 1059.219)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2289.965 1045.035)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2296.624 1054.419)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2295.414 1055.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2297.23 1058.657)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2297.23 1061.079)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2297.23 1062.895)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2292.992 1058.657)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2292.992 1058.052)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2292.992 1055.025)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2290.57 1053.814)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2290.57 1052.603)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2288.754 1051.997)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2287.24 1050.787)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2286.03 1050.787)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2288.754 1046.246)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2285.754 1047.852)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2283.003 1046.852)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2283.003 1052.603)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2279.673 1045.035)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2281.792 1051.392)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2279.067 1041.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2280.673 1038.954)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2277.856 1042.008)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2276.646 1043.824)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2280.884 1043.219)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(-2281.792 1045.035)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetScatter);
export default __webpack_public_path__ + "static/media/widget-scatter.6fb9e575.svg";
export { ForwardRef as ReactComponent };